import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import { Link } from "react-router-dom";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import Avatar from "assets/images/Avatar.png";
import PersonIcon from "@mui/icons-material/Person";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import DeletedLabel from "components/DeletedLabel";
import isUserDeleted from "utils/isUserDeleted";

function Author({ image, name, cityName, px }) {
  return (
    <SoftBox display="flex" alignItems="center" px={px} py={0.5}>
      {cityName ? (
        <SoftBox
          mr={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 36,
            height: 36,
            borderRadius: "100%",
            backgroundColor: "#E2E2E2",
            p: 0,
            flexShrink: 0,
          }}
        >
          <LocationCityOutlinedIcon sx={{ height: 20, width: 20, color: "#555F73" }} />
        </SoftBox>
      ) : (
        <SoftBox mr={2}>
          <SoftAvatar src={image} alt={name} size="sm" />
        </SoftBox>
      )}
      <Link>
        <SoftBox display="flex" flexDirection="column">
          <SoftTypography
            sx={{ fontSize: 14, color: "black.main", textTransform: "capitalize" }}
            fontWeight="normal"
          >
            {cityName && cityName !== "" ? cityName : name}
          </SoftTypography>
        </SoftBox>
      </Link>
    </SoftBox>
  );
}

export const columns = [
  { name: "user name", align: "left" },
  { name: "school/city", align: "left" },
  { name: "email", align: "left" },
  { name: "status", align: "center" },
  { name: "action", align: "left" },
];

const colormap = {
  active: "green",
  inactive: "error",
  restricted: "dark",
};

function Rows(data, setDialogue, returnPath) {
  const isDeleted = isUserDeleted(data);

  return {
    linkPath: `/user-details/${data?._id}`,
    returnPath,
    isDeleted,

    noLinkCells: ["action", "status"],

    "user name": <Author name={data?.name} image={data?.profile_pictures[0] || Avatar} px={1} />,

    email: (
      <SoftBox display="flex" alignItems="center" justifyContent="start">
        <SoftBox height="30px" />
        <SoftTypography
          sx={{ fontSize: 14, color: "black.main", textTransform: "none" }}
          fontWeight="normal"
        >
          {data?.email}
        </SoftTypography>
      </SoftBox>
    ),

    "school/city": <Author name={data?.school?.school_name} image={data?.school?.school_image} cityName={data?.school?.city} px={0} />,

    status: (
      <SoftBox display="flex" alignItems="center" justifyContent="start" px={1}>
        <SoftBox height="30px" />
        {isDeleted ? (
          <SoftBox display="flex" alignItems="center" justifyContent="center" px={1}>
            ---
          </SoftBox>
        ) : (
          <SoftBox
            borderRadius="xxl"
            display="flex"
            sx={{
              backgroundColor:
                data?.status == "active"
                  ? "green.main"
                  : data?.status == "inactive"
                    ? "mediumgray.main"
                    : "error.main",
              width: "100%",
              py: 0.8,
              gap: 1,
              px: 2,
              alignItems: "center",
              justifyContent: "center",
              whiteSpace: "nowrap",
            }}
          >
            <SoftTypography
              fontWeight="normal"
              sx={{ color: "white.main", fontSize: 16, textTransform: "capitalize" }}
            >
              {data?.status}
            </SoftTypography>
          </SoftBox>
        )}
      </SoftBox>
    ),

    action: isDeleted ? (
      <SoftBox display="flex" alignItems="center" justifyContent="center" px={1}>
        <SoftBox height="30px" />
        <DeletedLabel />
      </SoftBox>
    ) : !data?.is_active ? (
      <SoftBox
           onClick={() =>
          setDialogue({
            type: "activateDeactivateUser",
            isOpen: true,
            action: "activate",
            userId: data?._id,
          })
        }
        borderRadius="xxl"
        display="flex"
        sx={{
          backgroundColor: "green.light",
          width: "100%",
          py: 0.8,
          gap: 1,
          px: 1,
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        <PersonIcon sx={{ height: 20, width: 20, color: "green.main" }} />
        <SoftTypography
          fontWeight="normal"
          sx={{ color: "green.main", fontSize: 13, textTransform: "capitalize" }}
        >
          Activate user
        </SoftTypography>
      </SoftBox>
    ) : (
      <SoftBox
        onClick={() =>
          setDialogue({
            type: "activateDeactivateUser",
            isOpen: true,
            action: "deactivate",
            userId: data?._id,
          })
        }
        borderRadius="xxl"
        display="flex"
        sx={{
          backgroundColor: "red.light",
          width: "100%",
          py: 0.8,
          gap: 1,
          px: 1,
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        <PersonOffIcon sx={{ height: 20, width: 20, color: "red.main" }} />
        <SoftTypography
          fontWeight="normal"
          sx={{ color: "red.main", fontSize: 13, textTransform: "capitalize" }}
        >
          Deactivate user
        </SoftTypography>
      </SoftBox>
    ),
  };
}

export default Rows;
